import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#03a87c',
      light: '#04c795',
      dark: '#03624c',
    },
    secondary: {
      main: '#fe6807',
      light: '#ff7d2e',
      dark: '#e55a00',
    },
    background: {
      default: '#000B18',
      paper: 'rgba(30, 30, 30, 0.9)',
    },
    text: {
      primary: '#f5f5f5',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontFamily: "'Lobster', cursive",
      fontSize: '2rem',
      fontWeight: 400,
    },
    h2: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.7,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
        },
        containedPrimary: {
          background: 'linear-gradient(90deg, #03a87c 0%, #05c795 100%)',
          boxShadow: '0 10px 20px rgba(3, 168, 124, 0.3)',
          '&:hover': {
            boxShadow: '0 15px 30px rgba(3, 168, 124, 0.4)',
            background: 'linear-gradient(90deg, #03a87c 0%, #07d8a3 100%)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(90deg, #fe6807 0%, #ff8a3d 100%)',
          boxShadow: '0 10px 20px rgba(254, 104, 7, 0.3)',
          '&:hover': {
            boxShadow: '0 15px 30px rgba(254, 104, 7, 0.4)',
            background: 'linear-gradient(90deg, #fe6807 0%, #ff983d 100%)',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '2rem',
          paddingRight: '2rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          background: 'linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#000B18',
          backgroundImage: 'none',
          backgroundColor: '#000B18',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(0, 229, 255, 0.1)',
        }
      }
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
});

export default theme; 